import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';
import StatusBadge from '../components/shared/StatusBadge';

export default function Payments() {
  const [orders, setOrders] = useState([]);
  const load = () => api.get('/orders?status_filter=AWAITING_VERIFICATION').then(({ data }) => setOrders(data.items));
  useEffect(() => { load(); }, []);
  const fmt = (n) => '₹' + Number(n || 0).toLocaleString('en-IN');

  return (
    <div className="space-y-5 fade-up">
      <div className="fab-card p-5 bg-gradient-to-r from-orange-50 to-white border-l-4 border-fab-orange">
        <div className="font-display font-bold text-fab-text">⚠️ {orders.length} payments awaiting your verification</div>
        <p className="text-[12px] text-fab-text-secondary mt-1">Review buyer payment screenshots and confirm or reject.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {orders.map((o) => (
          <Link to={`/dashboard/orders/${o.id}`} key={o.id} className="fab-card overflow-hidden hover:shadow-md transition-shadow">
            <img src={o.payment?.screenshot_url || 'https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?w=400'} alt="payment" className="w-full h-40 object-cover" />
            <div className="p-4">
              <div className="flex items-center justify-between mb-1">
                <div className="font-mono font-bold text-fab-primary">{o.order_number}</div>
                <StatusBadge status={o.status} size="sm" />
              </div>
              <div className="text-[13px] text-fab-text">{o.buyer_name}</div>
              <div className="text-[12px] text-fab-text-muted">{o.buyer_phone}</div>
              <div className="mt-2 font-display font-bold text-fab-text">{fmt(o.total_amount)}</div>
            </div>
          </Link>
        ))}
        {orders.length === 0 && <div className="col-span-full text-center text-fab-text-muted py-12">No pending verifications 🎉</div>}
      </div>
    </div>
  );
}
